// write-unit8.js

var constant = exports.uint8 = new Array(256);

for (var i = 0x00; i <= 0xFF; i++) {
  constant[i] = write0(i);
}

function write0(type) {
  return function(encoder) {
    var offset = encoder.reserve(1);
    encoder.buffer[offset] = type;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/msgpack-lite/lib/write-uint8.js
// module id = 619
// module chunks = 10